import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/frontend/src/components/Copilot/CopilotPage.tsx");
